import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    text?: string | ReactNode;
    children?: ReactNode;
    className?: string;
}

export const ResponsiveTableRow = (props: IProps) => {
    const {title, text, children, className} = props;

    return (
        <tr className={cx(responsiveTableRowBase, className)}>
            <th className={responsiveTableHeader} scope="row">
                <Text variant="body_copy_1" className={responsiveTableRowTitle}>
                    {title}
                </Text>
            </th>

            <td className={responsiveTableCell}>
                <div className={tableCellWrapper}>
                    {text && (
                        <Text variant="body_copy_2" as="div">
                            {text}
                        </Text>
                    )}

                    {children && children}
                </div>
            </td>
        </tr>
    );
};

const responsiveTableRowBase = css({
    display: "block",
    whiteSpace: "pre-line",
    borderBottom: "1px solid var(--colors-gray-200)",

    sm: {
        display: "table-row"
    },

    "&:last-of-type": {
        borderBottom: "0 none"
    }
});

const responsiveTableHeader = css({
    display: "block",
    padding: 0,
    border: 0,
    textAlign: "left",
    fontWeight: "normal",

    sm: {
        display: "table-cell",
        width: "35%",
        verticalAlign: "middle"
    }
});

const responsiveTableRowTitle = css({
    py: 1,
    fontWeight: 400,
    color: "var(--colors-gray-700)",

    sm: {
        py: 3,
        pr: 2
    }
});

const responsiveTableCell = css({
    display: "block",
    padding: 0,
    border: 0,

    sm: {
        display: "table-cell",
        verticalAlign: "middle",
        width: "65%"
    }
});

const tableCellWrapper = css({
    pb: 1,

    sm: {
        pb: 0
    }
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    text?: string | ReactNode;
    children?: ReactNode;
    className?: string;
}

export const ResponsiveTableRow = (props: IProps) => {
    const {title, text, children, className} = props;

    return (
        <tr className={cx(responsiveTableRowBase, className)}>
            <th className={responsiveTableHeader} scope="row">
                <Text variant="body_copy_1" className={responsiveTableRowTitle}>
                    {title}
                </Text>
            </th>

            <td className={responsiveTableCell}>
                <div className={tableCellWrapper}>
                    {text && (
                        <Text variant="body_copy_2" as="div">
                            {text}
                        </Text>
                    )}

                    {children && children}
                </div>
            </td>
        </tr>
    );
};

const responsiveTableRowBase = css({
    display: "block",
    whiteSpace: "pre-line",
    borderBottom: "1px solid var(--colors-gray-200)",

    sm: {
        display: "table-row"
    },

    "&:last-of-type": {
        borderBottom: "0 none"
    }
});

const responsiveTableHeader = css({
    display: "block",
    padding: 0,
    border: 0,
    textAlign: "left",
    fontWeight: "normal",

    sm: {
        display: "table-cell",
        width: "35%",
        verticalAlign: "middle"
    }
});

const responsiveTableRowTitle = css({
    py: 1,
    fontWeight: 400,
    color: "var(--colors-gray-700)",

    sm: {
        py: 3,
        pr: 2
    }
});

const responsiveTableCell = css({
    display: "block",
    padding: 0,
    border: 0,

    sm: {
        display: "table-cell",
        verticalAlign: "middle",
        width: "65%"
    }
});

const tableCellWrapper = css({
    pb: 1,

    sm: {
        pb: 0
    }
});
